export const LOGOUT_USER = 'LOGOUT_USER';



